import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import type { FC, ReactNode } from 'react';
import theme from './theme.ts';

interface IProps {
  children: ReactNode;
}

const MuiThemeProvider: FC<IProps> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  </StyledEngineProvider>
);

export default MuiThemeProvider;
